/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { formatLieuIndividuFiche } from './formatters';

/**
 * Construit le payload de mise à jour du panel « EVENEMENT » (naissance) de
 * la fiche acte, envoyé via `service.update` (PUT `/numerisation-actes/naissance/{identifiant}`).
 *
 * Le lieu de naissance est édité via `LieuNaissance` (même composant que
 * l'assistant), dont l'état interne est imbriqué (`data.adresseNaissance`) ;
 * on l'aplatit ici vers les champs `naissance*` tels que reçus en lecture
 * dans la fiche (`naissancePays`, pas `naissancePaysLibelle` comme à la
 * création — contrat différent entre création et mise à jour).
 */
const buildEvenementNaissanceUpdatePayload = (
  identifiant: number,
  identifiantEnfant: number,
  data: Record<string, any>,
) => ({
  identifiant,
  enfant: {
    identifiant: identifiantEnfant,
    naissanceDate: data?.naissanceDate,
    naissanceHeure: data?.naissanceHeure,
    naissanceMinute: data?.naissanceMinute,
    ...formatLieuIndividuFiche(data?.adresseNaissance),
  },
});

export default buildEvenementNaissanceUpdatePayload;
